module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _c('Header'), (_vm.props) ? _c('div', {
    staticClass: "homecontent"
  }, [_c('div', {
    staticClass: "homepageslider"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.acf.home_slider), function(homeSlider) {
    return _c('swiper-slide', [(homeSlider.slider_image) ? _c('img', {
      attrs: {
        "src": homeSlider.slider_image
      }
    }) : _vm._e()])
  }), (_vm.props.acf.slider_caption) ? _c('div', {
    staticClass: "slider-caption",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.slider_caption)
    }
  }) : _vm._e()], 2)], 1)]), _c('div', [_c('div', {
    staticClass: "callouts"
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.props.acf.call_to_action), function(cta) {
    return (_vm.props) ? _c('div', {
      staticClass: "cta-box"
    }, [(cta.cta_link) ? _c('router-link', {
      attrs: {
        "to": cta.cta_link
      }
    }, [(cta.cta_image) ? _c('img', {
      attrs: {
        "src": cta.cta_image,
        "alt": ""
      }
    }) : _vm._e(), (cta.cta_heading) ? _c('h4', {
      domProps: {
        "innerHTML": _vm._s(cta.cta_heading)
      }
    }) : _vm._e(), (cta.cta_desc) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(cta.cta_desc)
      }
    }) : _vm._e(), _c('span', {
      staticClass: "learn-more"
    }, [_vm._v("Learn More")])]) : _vm._e()], 1) : _vm._e()
  }))]), _c('div', {
    staticClass: "home-about"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.props.acf.welcome_title) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_title)
    }
  }) : _vm._e(), (_vm.props.acf.welcome_text) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_text)
    }
  }) : _vm._e()])])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d043cb2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 1290
// module chunks = 1